export type LibraryToolbarControl =
  'explode' |
  'hide' |
  'home' |
  'isolate' |
  'redo' |
  'resetCamera' |
  'undo'

export function getLibraryNodeChanges (currentDbIds: number[], nextDbIds: number[]) {
  const currentIds = new Set(currentDbIds)
  const nextIds = new Set(nextDbIds)

  return {
    addedDbIds: nextDbIds.filter(dbId => !currentIds.has(dbId)),
    removedDbIds: currentDbIds.filter(dbId => !nextIds.has(dbId))
  }
}

export function getLibraryToolbarControls (
  enableExplode: boolean,
  showAdvancedSelectionControls: boolean
): LibraryToolbarControl[] {
  if (!enableExplode && !showAdvancedSelectionControls) {
    return ['resetCamera']
  }

  return [
    'home',
    ...(enableExplode ? ['explode'] as const : []),
    ...(showAdvancedSelectionControls ? ['hide', 'isolate'] as const : []),
    'undo',
    'redo',
    'resetCamera'
  ]
}
